<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" />

        <v-row>
          <v-col cols="12">
            <leave-report-relax-stat-filter @search="onSearch" />
          </v-col>

          <v-col>
            <leave-report-result v-model="downloading" />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import LeaveReportRelaxStatFilter from '@/components/leave/LeaveReport/LeaveReportRelaxStatFilter'
import LeaveReportResult from '@/components/leave/LeaveReport/LeaveReportResult'

export default {
  components: {
    LeaveReportRelaxStatFilter,
    LeaveReportResult
  },

  data() {
    return {
      empInfo: {},
      downloading: false
    }
  },

  computed: {
    title() {
      console.log(this.empInfo)
      const txt = 'ตรวจสอบวันลาสะสมของ'
      return txt + ' ' + this.empName
    },

    empName() {
      if (this.empInfo.hasOwnProperty('employeeNameTha')) {
        return this.empInfo[`employeeName${this.$lang}`]
      } else {
        return ''
      }
    }
  },

  async mounted() {
    if (this.$guid !== this.$guid_self) {
      this.empInfo = (await this.apiGetEmpName()) || {}
    }
  },

  methods: {
    onSearch() {
      this.downloading = true
    },
    async apiGetEmpName() {
      try {
        const res = await this.$store.dispatch('user/getInfo', this.$guid)
        return res.data?.data[0] || {}
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
